import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';

const CartContext = createContext(null);
const STORAGE_KEY = 'xtra_cart';

export const CartProvider = ({ children }) => {
    const [items, setItems] = useState(() => {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            return raw ? JSON.parse(raw) : [];
        } catch { return []; }
    });
    const [drawerOpen, setDrawerOpen] = useState(false);

    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    }, [items]);

    const addItem = useCallback((product, qty = 1) => {
        setItems((prev) => {
            const existing = prev.find((i) => i.product_id === product.id);
            if (existing) {
                return prev.map((i) => i.product_id === product.id ? { ...i, qty: i.qty + qty } : i);
            }
            return [...prev, {
                product_id: product.id,
                slug: product.slug,
                name: product.name,
                price: product.price,
                image: product.image,
                size: product.size,
                qty,
            }];
        });
        setDrawerOpen(true);
    }, []);

    const updateQty = useCallback((productId, qty) => {
        setItems((prev) => prev
            .map((i) => i.product_id === productId ? { ...i, qty: Math.max(1, qty) } : i));
    }, []);

    const removeItem = useCallback((productId) => {
        setItems((prev) => prev.filter((i) => i.product_id !== productId));
    }, []);

    const clearCart = useCallback(() => setItems([]), []);

    const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
    const count = items.reduce((s, i) => s + i.qty, 0);
    const shipping = subtotal >= 499 || subtotal === 0 ? 0 : 49;
    const total = subtotal + shipping;

    return (
        <CartContext.Provider value={{
            items, addItem, updateQty, removeItem, clearCart,
            subtotal, count, shipping, total,
            drawerOpen, setDrawerOpen,
        }}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => useContext(CartContext);
